/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as SkillsRouteImport } from './routes/skills'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as McpConnectionsRouteImport } from './routes/mcp-connections'
import { Route as KnowledgeGraphsRouteImport } from './routes/knowledge-graphs'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as AppConnectionsRouteImport } from './routes/app-connections'
import { Route as ApiKeysRouteImport } from './routes/api-keys'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkspacesIndexRouteImport } from './routes/workspaces/index'
import { Route as WorkflowsIndexRouteImport } from './routes/workflows/index'
import { Route as TracesIndexRouteImport } from './routes/traces/index'
import { Route as TasksIndexRouteImport } from './routes/tasks/index'
import { Route as SuitesIndexRouteImport } from './routes/suites/index'
import { Route as SchedulesIndexRouteImport } from './routes/schedules/index'
import { Route as OrchestratorIndexRouteImport } from './routes/orchestrator/index'
import { Route as ModelsIndexRouteImport } from './routes/models/index'
import { Route as MemoryIndexRouteImport } from './routes/memory/index'
import { Route as JudgesIndexRouteImport } from './routes/judges/index'
import { Route as InternalIndexRouteImport } from './routes/internal/index'
import { Route as InboxIndexRouteImport } from './routes/inbox/index'
import { Route as GroundTruthIndexRouteImport } from './routes/ground-truth/index'
import { Route as FeedbackIndexRouteImport } from './routes/feedback/index'
import { Route as EvalsIndexRouteImport } from './routes/evals/index'
import { Route as DocumentSetsIndexRouteImport } from './routes/document-sets/index'
import { Route as DashboardsIndexRouteImport } from './routes/dashboards/index'
import { Route as ChatIndexRouteImport } from './routes/chat/index'
import { Route as BoardColumnsIndexRouteImport } from './routes/board-columns/index'
import { Route as AgentsIndexRouteImport } from './routes/agents/index'
import { Route as WorkspacesIdRouteImport } from './routes/workspaces/$id'
import { Route as TracesTraceIdRouteImport } from './routes/traces/$traceId'
import { Route as TasksNewRouteImport } from './routes/tasks/new'
import { Route as TasksTaskIdRouteImport } from './routes/tasks/$taskId'
import { Route as SuitesNewRouteImport } from './routes/suites/new'
import { Route as SuitesSuiteIdRouteImport } from './routes/suites/$suiteId'
import { Route as SignalsIdRouteImport } from './routes/signals/$id'
import { Route as OrchestratorLiveRouteImport } from './routes/orchestrator/live'
import { Route as OrchestratorAnalyticsRouteImport } from './routes/orchestrator/analytics'
import { Route as ModelsNewRouteImport } from './routes/models/new'
import { Route as ModelsModelIdRouteImport } from './routes/models/$modelId'
import { Route as JudgesNewRouteImport } from './routes/judges/new'
import { Route as JudgesJudgeIdRouteImport } from './routes/judges/$judgeId'
import { Route as InternalRemoteRealtimeToolsRouteImport } from './routes/internal/remote-realtime-tools'
import { Route as InternalKnowledgeGraphsRouteImport } from './routes/internal/knowledge-graphs'
import { Route as InboxCoordinatorRouteImport } from './routes/inbox/coordinator'
import { Route as InboxClosedSignalsRouteImport } from './routes/inbox/closed-signals'
import { Route as InboxBoardRouteImport } from './routes/inbox/board'
import { Route as GroundTruthNewRouteImport } from './routes/ground-truth/new'
import { Route as GroundTruthBulkRouteImport } from './routes/ground-truth/bulk'
import { Route as EvalsNewRouteImport } from './routes/evals/new'
import { Route as DocumentSetsSetIdRouteImport } from './routes/document-sets/$setId'
import { Route as DashboardsDashboardIdRouteImport } from './routes/dashboards/$dashboardId'
import { Route as ChatThreadIdRouteImport } from './routes/chat/$threadId'
import { Route as BotThreadIdRouteImport } from './routes/bot/$threadId'
import { Route as BoardColumnsNewRouteImport } from './routes/board-columns/new'
import { Route as BoardColumnsColumnIdRouteImport } from './routes/board-columns/$columnId'
import { Route as AgentsSkillsRouteImport } from './routes/agents/skills'
import { Route as AgentsSessionsRouteImport } from './routes/agents/sessions'
import { Route as AgentsNewRouteImport } from './routes/agents/new'
import { Route as AgentsCollectionsRouteImport } from './routes/agents/collections'
import { Route as AgentsAutoApproveRouteImport } from './routes/agents/auto-approve'
import { Route as AgentsAssistantRouteImport } from './routes/agents/assistant'
import { Route as AgentsAgentIdRouteImport } from './routes/agents/$agentId'
import { Route as WorkflowsAgentsIndexRouteImport } from './routes/workflows/agents/index'
import { Route as WorkflowsWorkflowIdIndexRouteImport } from './routes/workflows/$workflowId/index'
import { Route as TriageRunsIndexRouteImport } from './routes/triage/runs/index'
import { Route as TriageHitlIndexRouteImport } from './routes/triage/hitl/index'
import { Route as RefinementSchedulesIndexRouteImport } from './routes/refinement/schedules/index'
import { Route as RefinementOverviewIndexRouteImport } from './routes/refinement/overview/index'
import { Route as RefinementHistoryIndexRouteImport } from './routes/refinement/history/index'
import { Route as MemoryMetricsIndexRouteImport } from './routes/memory/metrics/index'
import { Route as InternalPipelinesIndexRouteImport } from './routes/internal/pipelines/index'
import { Route as InternalOrganizationsIndexRouteImport } from './routes/internal/organizations/index'
import { Route as InternalBlueprintsIndexRouteImport } from './routes/internal/blueprints/index'
import { Route as EvalsEvalIdIndexRouteImport } from './routes/evals/$evalId/index'
import { Route as AgentsOrchestrationIndexRouteImport } from './routes/agents/orchestration/index'
import { Route as AgentsMemoriesIndexRouteImport } from './routes/agents/memories/index'
import { Route as WorkflowsAgentsNewRouteImport } from './routes/workflows/agents/new'
import { Route as WorkflowsAgentsAgentIdRouteImport } from './routes/workflows/agents/$agentId'
import { Route as TriageRunsRunIdRouteImport } from './routes/triage/runs/$runId'
import { Route as TriageHitlRunIdRouteImport } from './routes/triage/hitl/$runId'
import { Route as InternalPipelinesNewRouteImport } from './routes/internal/pipelines/new'
import { Route as InternalPipelinesPipelineIdRouteImport } from './routes/internal/pipelines/$pipelineId'
import { Route as InternalOrganizationsNewRouteImport } from './routes/internal/organizations/new'
import { Route as InternalOrganizationsOrgIdRouteImport } from './routes/internal/organizations/$orgId'
import { Route as InternalBlueprintsNewRouteImport } from './routes/internal/blueprints/new'
import { Route as InternalBlueprintsBlueprintIdRouteImport } from './routes/internal/blueprints/$blueprintId'
import { Route as InboxHitlRunIdRouteImport } from './routes/inbox/hitl/$runId'
import { Route as InboxElicitationElicitationIdRouteImport } from './routes/inbox/elicitation/$elicitationId'
import { Route as EvalsEvalIdNodesRouteImport } from './routes/evals/$evalId/nodes'
import { Route as AgentsOrchestrationSignalsRouteImport } from './routes/agents/orchestration/signals'
import { Route as AgentsMemoriesMetricsRouteImport } from './routes/agents/memories/metrics'
import { Route as AgentsMemoriesDigestRouteImport } from './routes/agents/memories/digest'
import { Route as AgentsOrchestrationSpecsIndexRouteImport } from './routes/agents/orchestration/specs/index'
import { Route as AgentsOrchestrationFilesystemsIndexRouteImport } from './routes/agents/orchestration/filesystems/index'
import { Route as AgentsOrchestrationBenchmarksIndexRouteImport } from './routes/agents/orchestration/benchmarks/index'
import { Route as AgentsOrchestrationSpecsSpecIdRouteImport } from './routes/agents/orchestration/specs/$specId'
import { Route as AgentsOrchestrationFilesystemsFilesystemIdRouteImport } from './routes/agents/orchestration/filesystems/$filesystemId'
import { Route as AgentsOrchestrationBenchmarksBenchmarkIdRouteImport } from './routes/agents/orchestration/benchmarks/$benchmarkId'
import { Route as AgentsAgentIdThreadsThreadIdRouteImport } from './routes/agents/$agentId_/threads/$threadId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const SkillsRoute = SkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const McpConnectionsRoute = McpConnectionsRouteImport.update({
  id: '/mcp-connections',
  path: '/mcp-connections',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeGraphsRoute = KnowledgeGraphsRouteImport.update({
  id: '/knowledge-graphs',
  path: '/knowledge-graphs',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const AppConnectionsRoute = AppConnectionsRouteImport.update({
  id: '/app-connections',
  path: '/app-connections',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiKeysRoute = ApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesIndexRoute = WorkspacesIndexRouteImport.update({
  id: '/workspaces/',
  path: '/workspaces/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowsIndexRoute = WorkflowsIndexRouteImport.update({
  id: '/workflows/',
  path: '/workflows/',
  getParentRoute: () => rootRouteImport,
} as any)
const TracesIndexRoute = TracesIndexRouteImport.update({
  id: '/traces/',
  path: '/traces/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuitesIndexRoute = SuitesIndexRouteImport.update({
  id: '/suites/',
  path: '/suites/',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulesIndexRoute = SchedulesIndexRouteImport.update({
  id: '/schedules/',
  path: '/schedules/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrchestratorIndexRoute = OrchestratorIndexRouteImport.update({
  id: '/orchestrator/',
  path: '/orchestrator/',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelsIndexRoute = ModelsIndexRouteImport.update({
  id: '/models/',
  path: '/models/',
  getParentRoute: () => rootRouteImport,
} as any)
const MemoryIndexRoute = MemoryIndexRouteImport.update({
  id: '/memory/',
  path: '/memory/',
  getParentRoute: () => rootRouteImport,
} as any)
const JudgesIndexRoute = JudgesIndexRouteImport.update({
  id: '/judges/',
  path: '/judges/',
  getParentRoute: () => rootRouteImport,
} as any)
const InternalIndexRoute = InternalIndexRouteImport.update({
  id: '/internal/',
  path: '/internal/',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxIndexRoute = InboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => rootRouteImport,
} as any)
const GroundTruthIndexRoute = GroundTruthIndexRouteImport.update({
  id: '/ground-truth/',
  path: '/ground-truth/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackIndexRoute = FeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => rootRouteImport,
} as any)
const EvalsIndexRoute = EvalsIndexRouteImport.update({
  id: '/evals/',
  path: '/evals/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentSetsIndexRoute = DocumentSetsIndexRouteImport.update({
  id: '/document-sets/',
  path: '/document-sets/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardsIndexRoute = DashboardsIndexRouteImport.update({
  id: '/dashboards/',
  path: '/dashboards/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const BoardColumnsIndexRoute = BoardColumnsIndexRouteImport.update({
  id: '/board-columns/',
  path: '/board-columns/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesIdRoute = WorkspacesIdRouteImport.update({
  id: '/workspaces/$id',
  path: '/workspaces/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TracesTraceIdRoute = TracesTraceIdRouteImport.update({
  id: '/traces/$traceId',
  path: '/traces/$traceId',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksNewRoute = TasksNewRouteImport.update({
  id: '/tasks/new',
  path: '/tasks/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksTaskIdRoute = TasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const SuitesNewRoute = SuitesNewRouteImport.update({
  id: '/suites/new',
  path: '/suites/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SuitesSuiteIdRoute = SuitesSuiteIdRouteImport.update({
  id: '/suites/$suiteId',
  path: '/suites/$suiteId',
  getParentRoute: () => rootRouteImport,
} as any)
const SignalsIdRoute = SignalsIdRouteImport.update({
  id: '/signals/$id',
  path: '/signals/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OrchestratorLiveRoute = OrchestratorLiveRouteImport.update({
  id: '/orchestrator/live',
  path: '/orchestrator/live',
  getParentRoute: () => rootRouteImport,
} as any)
const OrchestratorAnalyticsRoute = OrchestratorAnalyticsRouteImport.update({
  id: '/orchestrator/analytics',
  path: '/orchestrator/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelsNewRoute = ModelsNewRouteImport.update({
  id: '/models/new',
  path: '/models/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelsModelIdRoute = ModelsModelIdRouteImport.update({
  id: '/models/$modelId',
  path: '/models/$modelId',
  getParentRoute: () => rootRouteImport,
} as any)
const JudgesNewRoute = JudgesNewRouteImport.update({
  id: '/judges/new',
  path: '/judges/new',
  getParentRoute: () => rootRouteImport,
} as any)
const JudgesJudgeIdRoute = JudgesJudgeIdRouteImport.update({
  id: '/judges/$judgeId',
  path: '/judges/$judgeId',
  getParentRoute: () => rootRouteImport,
} as any)
const InternalRemoteRealtimeToolsRoute =
  InternalRemoteRealtimeToolsRouteImport.update({
    id: '/internal/remote-realtime-tools',
    path: '/internal/remote-realtime-tools',
    getParentRoute: () => rootRouteImport,
  } as any)
const InternalKnowledgeGraphsRoute = InternalKnowledgeGraphsRouteImport.update({
  id: '/internal/knowledge-graphs',
  path: '/internal/knowledge-graphs',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxCoordinatorRoute = InboxCoordinatorRouteImport.update({
  id: '/inbox/coordinator',
  path: '/inbox/coordinator',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxClosedSignalsRoute = InboxClosedSignalsRouteImport.update({
  id: '/inbox/closed-signals',
  path: '/inbox/closed-signals',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxBoardRoute = InboxBoardRouteImport.update({
  id: '/inbox/board',
  path: '/inbox/board',
  getParentRoute: () => rootRouteImport,
} as any)
const GroundTruthNewRoute = GroundTruthNewRouteImport.update({
  id: '/ground-truth/new',
  path: '/ground-truth/new',
  getParentRoute: () => rootRouteImport,
} as any)
const GroundTruthBulkRoute = GroundTruthBulkRouteImport.update({
  id: '/ground-truth/bulk',
  path: '/ground-truth/bulk',
  getParentRoute: () => rootRouteImport,
} as any)
const EvalsNewRoute = EvalsNewRouteImport.update({
  id: '/evals/new',
  path: '/evals/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentSetsSetIdRoute = DocumentSetsSetIdRouteImport.update({
  id: '/document-sets/$setId',
  path: '/document-sets/$setId',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardsDashboardIdRoute = DashboardsDashboardIdRouteImport.update({
  id: '/dashboards/$dashboardId',
  path: '/dashboards/$dashboardId',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatThreadIdRoute = ChatThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => ChatRoute,
} as any)
const BotThreadIdRoute = BotThreadIdRouteImport.update({
  id: '/bot/$threadId',
  path: '/bot/$threadId',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardColumnsNewRoute = BoardColumnsNewRouteImport.update({
  id: '/board-columns/new',
  path: '/board-columns/new',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardColumnsColumnIdRoute = BoardColumnsColumnIdRouteImport.update({
  id: '/board-columns/$columnId',
  path: '/board-columns/$columnId',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsSkillsRoute = AgentsSkillsRouteImport.update({
  id: '/agents/skills',
  path: '/agents/skills',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsSessionsRoute = AgentsSessionsRouteImport.update({
  id: '/agents/sessions',
  path: '/agents/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsNewRoute = AgentsNewRouteImport.update({
  id: '/agents/new',
  path: '/agents/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsCollectionsRoute = AgentsCollectionsRouteImport.update({
  id: '/agents/collections',
  path: '/agents/collections',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAutoApproveRoute = AgentsAutoApproveRouteImport.update({
  id: '/agents/auto-approve',
  path: '/agents/auto-approve',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAssistantRoute = AgentsAssistantRouteImport.update({
  id: '/agents/assistant',
  path: '/agents/assistant',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAgentIdRoute = AgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowsAgentsIndexRoute = WorkflowsAgentsIndexRouteImport.update({
  id: '/workflows/agents/',
  path: '/workflows/agents/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowsWorkflowIdIndexRoute =
  WorkflowsWorkflowIdIndexRouteImport.update({
    id: '/workflows/$workflowId/',
    path: '/workflows/$workflowId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TriageRunsIndexRoute = TriageRunsIndexRouteImport.update({
  id: '/triage/runs/',
  path: '/triage/runs/',
  getParentRoute: () => rootRouteImport,
} as any)
const TriageHitlIndexRoute = TriageHitlIndexRouteImport.update({
  id: '/triage/hitl/',
  path: '/triage/hitl/',
  getParentRoute: () => rootRouteImport,
} as any)
const RefinementSchedulesIndexRoute =
  RefinementSchedulesIndexRouteImport.update({
    id: '/refinement/schedules/',
    path: '/refinement/schedules/',
    getParentRoute: () => rootRouteImport,
  } as any)
const RefinementOverviewIndexRoute = RefinementOverviewIndexRouteImport.update({
  id: '/refinement/overview/',
  path: '/refinement/overview/',
  getParentRoute: () => rootRouteImport,
} as any)
const RefinementHistoryIndexRoute = RefinementHistoryIndexRouteImport.update({
  id: '/refinement/history/',
  path: '/refinement/history/',
  getParentRoute: () => rootRouteImport,
} as any)
const MemoryMetricsIndexRoute = MemoryMetricsIndexRouteImport.update({
  id: '/memory/metrics/',
  path: '/memory/metrics/',
  getParentRoute: () => rootRouteImport,
} as any)
const InternalPipelinesIndexRoute = InternalPipelinesIndexRouteImport.update({
  id: '/internal/pipelines/',
  path: '/internal/pipelines/',
  getParentRoute: () => rootRouteImport,
} as any)
const InternalOrganizationsIndexRoute =
  InternalOrganizationsIndexRouteImport.update({
    id: '/internal/organizations/',
    path: '/internal/organizations/',
    getParentRoute: () => rootRouteImport,
  } as any)
const InternalBlueprintsIndexRoute = InternalBlueprintsIndexRouteImport.update({
  id: '/internal/blueprints/',
  path: '/internal/blueprints/',
  getParentRoute: () => rootRouteImport,
} as any)
const EvalsEvalIdIndexRoute = EvalsEvalIdIndexRouteImport.update({
  id: '/evals/$evalId/',
  path: '/evals/$evalId/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsOrchestrationIndexRoute =
  AgentsOrchestrationIndexRouteImport.update({
    id: '/agents/orchestration/',
    path: '/agents/orchestration/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgentsMemoriesIndexRoute = AgentsMemoriesIndexRouteImport.update({
  id: '/agents/memories/',
  path: '/agents/memories/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowsAgentsNewRoute = WorkflowsAgentsNewRouteImport.update({
  id: '/workflows/agents/new',
  path: '/workflows/agents/new',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowsAgentsAgentIdRoute = WorkflowsAgentsAgentIdRouteImport.update({
  id: '/workflows/agents/$agentId',
  path: '/workflows/agents/$agentId',
  getParentRoute: () => rootRouteImport,
} as any)
const TriageRunsRunIdRoute = TriageRunsRunIdRouteImport.update({
  id: '/triage/runs/$runId',
  path: '/triage/runs/$runId',
  getParentRoute: () => rootRouteImport,
} as any)
const TriageHitlRunIdRoute = TriageHitlRunIdRouteImport.update({
  id: '/triage/hitl/$runId',
  path: '/triage/hitl/$runId',
  getParentRoute: () => rootRouteImport,
} as any)
const InternalPipelinesNewRoute = InternalPipelinesNewRouteImport.update({
  id: '/internal/pipelines/new',
  path: '/internal/pipelines/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InternalPipelinesPipelineIdRoute =
  InternalPipelinesPipelineIdRouteImport.update({
    id: '/internal/pipelines/$pipelineId',
    path: '/internal/pipelines/$pipelineId',
    getParentRoute: () => rootRouteImport,
  } as any)
const InternalOrganizationsNewRoute =
  InternalOrganizationsNewRouteImport.update({
    id: '/internal/organizations/new',
    path: '/internal/organizations/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const InternalOrganizationsOrgIdRoute =
  InternalOrganizationsOrgIdRouteImport.update({
    id: '/internal/organizations/$orgId',
    path: '/internal/organizations/$orgId',
    getParentRoute: () => rootRouteImport,
  } as any)
const InternalBlueprintsNewRoute = InternalBlueprintsNewRouteImport.update({
  id: '/internal/blueprints/new',
  path: '/internal/blueprints/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InternalBlueprintsBlueprintIdRoute =
  InternalBlueprintsBlueprintIdRouteImport.update({
    id: '/internal/blueprints/$blueprintId',
    path: '/internal/blueprints/$blueprintId',
    getParentRoute: () => rootRouteImport,
  } as any)
const InboxHitlRunIdRoute = InboxHitlRunIdRouteImport.update({
  id: '/inbox/hitl/$runId',
  path: '/inbox/hitl/$runId',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxElicitationElicitationIdRoute =
  InboxElicitationElicitationIdRouteImport.update({
    id: '/inbox/elicitation/$elicitationId',
    path: '/inbox/elicitation/$elicitationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const EvalsEvalIdNodesRoute = EvalsEvalIdNodesRouteImport.update({
  id: '/evals/$evalId/nodes',
  path: '/evals/$evalId/nodes',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsOrchestrationSignalsRoute =
  AgentsOrchestrationSignalsRouteImport.update({
    id: '/agents/orchestration/signals',
    path: '/agents/orchestration/signals',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgentsMemoriesMetricsRoute = AgentsMemoriesMetricsRouteImport.update({
  id: '/agents/memories/metrics',
  path: '/agents/memories/metrics',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsMemoriesDigestRoute = AgentsMemoriesDigestRouteImport.update({
  id: '/agents/memories/digest',
  path: '/agents/memories/digest',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsOrchestrationSpecsIndexRoute =
  AgentsOrchestrationSpecsIndexRouteImport.update({
    id: '/agents/orchestration/specs/',
    path: '/agents/orchestration/specs/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgentsOrchestrationFilesystemsIndexRoute =
  AgentsOrchestrationFilesystemsIndexRouteImport.update({
    id: '/agents/orchestration/filesystems/',
    path: '/agents/orchestration/filesystems/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgentsOrchestrationBenchmarksIndexRoute =
  AgentsOrchestrationBenchmarksIndexRouteImport.update({
    id: '/agents/orchestration/benchmarks/',
    path: '/agents/orchestration/benchmarks/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgentsOrchestrationSpecsSpecIdRoute =
  AgentsOrchestrationSpecsSpecIdRouteImport.update({
    id: '/agents/orchestration/specs/$specId',
    path: '/agents/orchestration/specs/$specId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgentsOrchestrationFilesystemsFilesystemIdRoute =
  AgentsOrchestrationFilesystemsFilesystemIdRouteImport.update({
    id: '/agents/orchestration/filesystems/$filesystemId',
    path: '/agents/orchestration/filesystems/$filesystemId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgentsOrchestrationBenchmarksBenchmarkIdRoute =
  AgentsOrchestrationBenchmarksBenchmarkIdRouteImport.update({
    id: '/agents/orchestration/benchmarks/$benchmarkId',
    path: '/agents/orchestration/benchmarks/$benchmarkId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgentsAgentIdThreadsThreadIdRoute =
  AgentsAgentIdThreadsThreadIdRouteImport.update({
    id: '/agents/$agentId_/threads/$threadId',
    path: '/agents/$agentId/threads/$threadId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/api-keys': typeof ApiKeysRoute
  '/app-connections': typeof AppConnectionsRoute
  '/chat': typeof ChatRouteWithChildren
  '/knowledge-graphs': typeof KnowledgeGraphsRoute
  '/mcp-connections': typeof McpConnectionsRoute
  '/settings': typeof SettingsRoute
  '/skills': typeof SkillsRoute
  '/users': typeof UsersRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/agents/assistant': typeof AgentsAssistantRoute
  '/agents/auto-approve': typeof AgentsAutoApproveRoute
  '/agents/collections': typeof AgentsCollectionsRoute
  '/agents/new': typeof AgentsNewRoute
  '/agents/sessions': typeof AgentsSessionsRoute
  '/agents/skills': typeof AgentsSkillsRoute
  '/board-columns/$columnId': typeof BoardColumnsColumnIdRoute
  '/board-columns/new': typeof BoardColumnsNewRoute
  '/bot/$threadId': typeof BotThreadIdRoute
  '/chat/$threadId': typeof ChatThreadIdRoute
  '/dashboards/$dashboardId': typeof DashboardsDashboardIdRoute
  '/document-sets/$setId': typeof DocumentSetsSetIdRoute
  '/evals/new': typeof EvalsNewRoute
  '/ground-truth/bulk': typeof GroundTruthBulkRoute
  '/ground-truth/new': typeof GroundTruthNewRoute
  '/inbox/board': typeof InboxBoardRoute
  '/inbox/closed-signals': typeof InboxClosedSignalsRoute
  '/inbox/coordinator': typeof InboxCoordinatorRoute
  '/internal/knowledge-graphs': typeof InternalKnowledgeGraphsRoute
  '/internal/remote-realtime-tools': typeof InternalRemoteRealtimeToolsRoute
  '/judges/$judgeId': typeof JudgesJudgeIdRoute
  '/judges/new': typeof JudgesNewRoute
  '/models/$modelId': typeof ModelsModelIdRoute
  '/models/new': typeof ModelsNewRoute
  '/orchestrator/analytics': typeof OrchestratorAnalyticsRoute
  '/orchestrator/live': typeof OrchestratorLiveRoute
  '/signals/$id': typeof SignalsIdRoute
  '/suites/$suiteId': typeof SuitesSuiteIdRoute
  '/suites/new': typeof SuitesNewRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/tasks/new': typeof TasksNewRoute
  '/traces/$traceId': typeof TracesTraceIdRoute
  '/workspaces/$id': typeof WorkspacesIdRoute
  '/agents/': typeof AgentsIndexRoute
  '/board-columns/': typeof BoardColumnsIndexRoute
  '/chat/': typeof ChatIndexRoute
  '/dashboards/': typeof DashboardsIndexRoute
  '/document-sets/': typeof DocumentSetsIndexRoute
  '/evals/': typeof EvalsIndexRoute
  '/feedback/': typeof FeedbackIndexRoute
  '/ground-truth/': typeof GroundTruthIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/internal/': typeof InternalIndexRoute
  '/judges/': typeof JudgesIndexRoute
  '/memory/': typeof MemoryIndexRoute
  '/models/': typeof ModelsIndexRoute
  '/orchestrator/': typeof OrchestratorIndexRoute
  '/schedules/': typeof SchedulesIndexRoute
  '/suites/': typeof SuitesIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/traces/': typeof TracesIndexRoute
  '/workflows/': typeof WorkflowsIndexRoute
  '/workspaces/': typeof WorkspacesIndexRoute
  '/agents/memories/digest': typeof AgentsMemoriesDigestRoute
  '/agents/memories/metrics': typeof AgentsMemoriesMetricsRoute
  '/agents/orchestration/signals': typeof AgentsOrchestrationSignalsRoute
  '/evals/$evalId/nodes': typeof EvalsEvalIdNodesRoute
  '/inbox/elicitation/$elicitationId': typeof InboxElicitationElicitationIdRoute
  '/inbox/hitl/$runId': typeof InboxHitlRunIdRoute
  '/internal/blueprints/$blueprintId': typeof InternalBlueprintsBlueprintIdRoute
  '/internal/blueprints/new': typeof InternalBlueprintsNewRoute
  '/internal/organizations/$orgId': typeof InternalOrganizationsOrgIdRoute
  '/internal/organizations/new': typeof InternalOrganizationsNewRoute
  '/internal/pipelines/$pipelineId': typeof InternalPipelinesPipelineIdRoute
  '/internal/pipelines/new': typeof InternalPipelinesNewRoute
  '/triage/hitl/$runId': typeof TriageHitlRunIdRoute
  '/triage/runs/$runId': typeof TriageRunsRunIdRoute
  '/workflows/agents/$agentId': typeof WorkflowsAgentsAgentIdRoute
  '/workflows/agents/new': typeof WorkflowsAgentsNewRoute
  '/agents/memories/': typeof AgentsMemoriesIndexRoute
  '/agents/orchestration/': typeof AgentsOrchestrationIndexRoute
  '/evals/$evalId/': typeof EvalsEvalIdIndexRoute
  '/internal/blueprints/': typeof InternalBlueprintsIndexRoute
  '/internal/organizations/': typeof InternalOrganizationsIndexRoute
  '/internal/pipelines/': typeof InternalPipelinesIndexRoute
  '/memory/metrics/': typeof MemoryMetricsIndexRoute
  '/refinement/history/': typeof RefinementHistoryIndexRoute
  '/refinement/overview/': typeof RefinementOverviewIndexRoute
  '/refinement/schedules/': typeof RefinementSchedulesIndexRoute
  '/triage/hitl/': typeof TriageHitlIndexRoute
  '/triage/runs/': typeof TriageRunsIndexRoute
  '/workflows/$workflowId/': typeof WorkflowsWorkflowIdIndexRoute
  '/workflows/agents/': typeof WorkflowsAgentsIndexRoute
  '/agents/$agentId/threads/$threadId': typeof AgentsAgentIdThreadsThreadIdRoute
  '/agents/orchestration/benchmarks/$benchmarkId': typeof AgentsOrchestrationBenchmarksBenchmarkIdRoute
  '/agents/orchestration/filesystems/$filesystemId': typeof AgentsOrchestrationFilesystemsFilesystemIdRoute
  '/agents/orchestration/specs/$specId': typeof AgentsOrchestrationSpecsSpecIdRoute
  '/agents/orchestration/benchmarks/': typeof AgentsOrchestrationBenchmarksIndexRoute
  '/agents/orchestration/filesystems/': typeof AgentsOrchestrationFilesystemsIndexRoute
  '/agents/orchestration/specs/': typeof AgentsOrchestrationSpecsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/api-keys': typeof ApiKeysRoute
  '/app-connections': typeof AppConnectionsRoute
  '/knowledge-graphs': typeof KnowledgeGraphsRoute
  '/mcp-connections': typeof McpConnectionsRoute
  '/settings': typeof SettingsRoute
  '/skills': typeof SkillsRoute
  '/users': typeof UsersRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/agents/assistant': typeof AgentsAssistantRoute
  '/agents/auto-approve': typeof AgentsAutoApproveRoute
  '/agents/collections': typeof AgentsCollectionsRoute
  '/agents/new': typeof AgentsNewRoute
  '/agents/sessions': typeof AgentsSessionsRoute
  '/agents/skills': typeof AgentsSkillsRoute
  '/board-columns/$columnId': typeof BoardColumnsColumnIdRoute
  '/board-columns/new': typeof BoardColumnsNewRoute
  '/bot/$threadId': typeof BotThreadIdRoute
  '/chat/$threadId': typeof ChatThreadIdRoute
  '/dashboards/$dashboardId': typeof DashboardsDashboardIdRoute
  '/document-sets/$setId': typeof DocumentSetsSetIdRoute
  '/evals/new': typeof EvalsNewRoute
  '/ground-truth/bulk': typeof GroundTruthBulkRoute
  '/ground-truth/new': typeof GroundTruthNewRoute
  '/inbox/board': typeof InboxBoardRoute
  '/inbox/closed-signals': typeof InboxClosedSignalsRoute
  '/inbox/coordinator': typeof InboxCoordinatorRoute
  '/internal/knowledge-graphs': typeof InternalKnowledgeGraphsRoute
  '/internal/remote-realtime-tools': typeof InternalRemoteRealtimeToolsRoute
  '/judges/$judgeId': typeof JudgesJudgeIdRoute
  '/judges/new': typeof JudgesNewRoute
  '/models/$modelId': typeof ModelsModelIdRoute
  '/models/new': typeof ModelsNewRoute
  '/orchestrator/analytics': typeof OrchestratorAnalyticsRoute
  '/orchestrator/live': typeof OrchestratorLiveRoute
  '/signals/$id': typeof SignalsIdRoute
  '/suites/$suiteId': typeof SuitesSuiteIdRoute
  '/suites/new': typeof SuitesNewRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/tasks/new': typeof TasksNewRoute
  '/traces/$traceId': typeof TracesTraceIdRoute
  '/workspaces/$id': typeof WorkspacesIdRoute
  '/agents': typeof AgentsIndexRoute
  '/board-columns': typeof BoardColumnsIndexRoute
  '/chat': typeof ChatIndexRoute
  '/dashboards': typeof DashboardsIndexRoute
  '/document-sets': typeof DocumentSetsIndexRoute
  '/evals': typeof EvalsIndexRoute
  '/feedback': typeof FeedbackIndexRoute
  '/ground-truth': typeof GroundTruthIndexRoute
  '/inbox': typeof InboxIndexRoute
  '/internal': typeof InternalIndexRoute
  '/judges': typeof JudgesIndexRoute
  '/memory': typeof MemoryIndexRoute
  '/models': typeof ModelsIndexRoute
  '/orchestrator': typeof OrchestratorIndexRoute
  '/schedules': typeof SchedulesIndexRoute
  '/suites': typeof SuitesIndexRoute
  '/tasks': typeof TasksIndexRoute
  '/traces': typeof TracesIndexRoute
  '/workflows': typeof WorkflowsIndexRoute
  '/workspaces': typeof WorkspacesIndexRoute
  '/agents/memories/digest': typeof AgentsMemoriesDigestRoute
  '/agents/memories/metrics': typeof AgentsMemoriesMetricsRoute
  '/agents/orchestration/signals': typeof AgentsOrchestrationSignalsRoute
  '/evals/$evalId/nodes': typeof EvalsEvalIdNodesRoute
  '/inbox/elicitation/$elicitationId': typeof InboxElicitationElicitationIdRoute
  '/inbox/hitl/$runId': typeof InboxHitlRunIdRoute
  '/internal/blueprints/$blueprintId': typeof InternalBlueprintsBlueprintIdRoute
  '/internal/blueprints/new': typeof InternalBlueprintsNewRoute
  '/internal/organizations/$orgId': typeof InternalOrganizationsOrgIdRoute
  '/internal/organizations/new': typeof InternalOrganizationsNewRoute
  '/internal/pipelines/$pipelineId': typeof InternalPipelinesPipelineIdRoute
  '/internal/pipelines/new': typeof InternalPipelinesNewRoute
  '/triage/hitl/$runId': typeof TriageHitlRunIdRoute
  '/triage/runs/$runId': typeof TriageRunsRunIdRoute
  '/workflows/agents/$agentId': typeof WorkflowsAgentsAgentIdRoute
  '/workflows/agents/new': typeof WorkflowsAgentsNewRoute
  '/agents/memories': typeof AgentsMemoriesIndexRoute
  '/agents/orchestration': typeof AgentsOrchestrationIndexRoute
  '/evals/$evalId': typeof EvalsEvalIdIndexRoute
  '/internal/blueprints': typeof InternalBlueprintsIndexRoute
  '/internal/organizations': typeof InternalOrganizationsIndexRoute
  '/internal/pipelines': typeof InternalPipelinesIndexRoute
  '/memory/metrics': typeof MemoryMetricsIndexRoute
  '/refinement/history': typeof RefinementHistoryIndexRoute
  '/refinement/overview': typeof RefinementOverviewIndexRoute
  '/refinement/schedules': typeof RefinementSchedulesIndexRoute
  '/triage/hitl': typeof TriageHitlIndexRoute
  '/triage/runs': typeof TriageRunsIndexRoute
  '/workflows/$workflowId': typeof WorkflowsWorkflowIdIndexRoute
  '/workflows/agents': typeof WorkflowsAgentsIndexRoute
  '/agents/$agentId/threads/$threadId': typeof AgentsAgentIdThreadsThreadIdRoute
  '/agents/orchestration/benchmarks/$benchmarkId': typeof AgentsOrchestrationBenchmarksBenchmarkIdRoute
  '/agents/orchestration/filesystems/$filesystemId': typeof AgentsOrchestrationFilesystemsFilesystemIdRoute
  '/agents/orchestration/specs/$specId': typeof AgentsOrchestrationSpecsSpecIdRoute
  '/agents/orchestration/benchmarks': typeof AgentsOrchestrationBenchmarksIndexRoute
  '/agents/orchestration/filesystems': typeof AgentsOrchestrationFilesystemsIndexRoute
  '/agents/orchestration/specs': typeof AgentsOrchestrationSpecsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/api-keys': typeof ApiKeysRoute
  '/app-connections': typeof AppConnectionsRoute
  '/chat': typeof ChatRouteWithChildren
  '/knowledge-graphs': typeof KnowledgeGraphsRoute
  '/mcp-connections': typeof McpConnectionsRoute
  '/settings': typeof SettingsRoute
  '/skills': typeof SkillsRoute
  '/users': typeof UsersRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/agents/assistant': typeof AgentsAssistantRoute
  '/agents/auto-approve': typeof AgentsAutoApproveRoute
  '/agents/collections': typeof AgentsCollectionsRoute
  '/agents/new': typeof AgentsNewRoute
  '/agents/sessions': typeof AgentsSessionsRoute
  '/agents/skills': typeof AgentsSkillsRoute
  '/board-columns/$columnId': typeof BoardColumnsColumnIdRoute
  '/board-columns/new': typeof BoardColumnsNewRoute
  '/bot/$threadId': typeof BotThreadIdRoute
  '/chat/$threadId': typeof ChatThreadIdRoute
  '/dashboards/$dashboardId': typeof DashboardsDashboardIdRoute
  '/document-sets/$setId': typeof DocumentSetsSetIdRoute
  '/evals/new': typeof EvalsNewRoute
  '/ground-truth/bulk': typeof GroundTruthBulkRoute
  '/ground-truth/new': typeof GroundTruthNewRoute
  '/inbox/board': typeof InboxBoardRoute
  '/inbox/closed-signals': typeof InboxClosedSignalsRoute
  '/inbox/coordinator': typeof InboxCoordinatorRoute
  '/internal/knowledge-graphs': typeof InternalKnowledgeGraphsRoute
  '/internal/remote-realtime-tools': typeof InternalRemoteRealtimeToolsRoute
  '/judges/$judgeId': typeof JudgesJudgeIdRoute
  '/judges/new': typeof JudgesNewRoute
  '/models/$modelId': typeof ModelsModelIdRoute
  '/models/new': typeof ModelsNewRoute
  '/orchestrator/analytics': typeof OrchestratorAnalyticsRoute
  '/orchestrator/live': typeof OrchestratorLiveRoute
  '/signals/$id': typeof SignalsIdRoute
  '/suites/$suiteId': typeof SuitesSuiteIdRoute
  '/suites/new': typeof SuitesNewRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/tasks/new': typeof TasksNewRoute
  '/traces/$traceId': typeof TracesTraceIdRoute
  '/workspaces/$id': typeof WorkspacesIdRoute
  '/agents/': typeof AgentsIndexRoute
  '/board-columns/': typeof BoardColumnsIndexRoute
  '/chat/': typeof ChatIndexRoute
  '/dashboards/': typeof DashboardsIndexRoute
  '/document-sets/': typeof DocumentSetsIndexRoute
  '/evals/': typeof EvalsIndexRoute
  '/feedback/': typeof FeedbackIndexRoute
  '/ground-truth/': typeof GroundTruthIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/internal/': typeof InternalIndexRoute
  '/judges/': typeof JudgesIndexRoute
  '/memory/': typeof MemoryIndexRoute
  '/models/': typeof ModelsIndexRoute
  '/orchestrator/': typeof OrchestratorIndexRoute
  '/schedules/': typeof SchedulesIndexRoute
  '/suites/': typeof SuitesIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/traces/': typeof TracesIndexRoute
  '/workflows/': typeof WorkflowsIndexRoute
  '/workspaces/': typeof WorkspacesIndexRoute
  '/agents/memories/digest': typeof AgentsMemoriesDigestRoute
  '/agents/memories/metrics': typeof AgentsMemoriesMetricsRoute
  '/agents/orchestration/signals': typeof AgentsOrchestrationSignalsRoute
  '/evals/$evalId/nodes': typeof EvalsEvalIdNodesRoute
  '/inbox/elicitation/$elicitationId': typeof InboxElicitationElicitationIdRoute
  '/inbox/hitl/$runId': typeof InboxHitlRunIdRoute
  '/internal/blueprints/$blueprintId': typeof InternalBlueprintsBlueprintIdRoute
  '/internal/blueprints/new': typeof InternalBlueprintsNewRoute
  '/internal/organizations/$orgId': typeof InternalOrganizationsOrgIdRoute
  '/internal/organizations/new': typeof InternalOrganizationsNewRoute
  '/internal/pipelines/$pipelineId': typeof InternalPipelinesPipelineIdRoute
  '/internal/pipelines/new': typeof InternalPipelinesNewRoute
  '/triage/hitl/$runId': typeof TriageHitlRunIdRoute
  '/triage/runs/$runId': typeof TriageRunsRunIdRoute
  '/workflows/agents/$agentId': typeof WorkflowsAgentsAgentIdRoute
  '/workflows/agents/new': typeof WorkflowsAgentsNewRoute
  '/agents/memories/': typeof AgentsMemoriesIndexRoute
  '/agents/orchestration/': typeof AgentsOrchestrationIndexRoute
  '/evals/$evalId/': typeof EvalsEvalIdIndexRoute
  '/internal/blueprints/': typeof InternalBlueprintsIndexRoute
  '/internal/organizations/': typeof InternalOrganizationsIndexRoute
  '/internal/pipelines/': typeof InternalPipelinesIndexRoute
  '/memory/metrics/': typeof MemoryMetricsIndexRoute
  '/refinement/history/': typeof RefinementHistoryIndexRoute
  '/refinement/overview/': typeof RefinementOverviewIndexRoute
  '/refinement/schedules/': typeof RefinementSchedulesIndexRoute
  '/triage/hitl/': typeof TriageHitlIndexRoute
  '/triage/runs/': typeof TriageRunsIndexRoute
  '/workflows/$workflowId/': typeof WorkflowsWorkflowIdIndexRoute
  '/workflows/agents/': typeof WorkflowsAgentsIndexRoute
  '/agents/$agentId_/threads/$threadId': typeof AgentsAgentIdThreadsThreadIdRoute
  '/agents/orchestration/benchmarks/$benchmarkId': typeof AgentsOrchestrationBenchmarksBenchmarkIdRoute
  '/agents/orchestration/filesystems/$filesystemId': typeof AgentsOrchestrationFilesystemsFilesystemIdRoute
  '/agents/orchestration/specs/$specId': typeof AgentsOrchestrationSpecsSpecIdRoute
  '/agents/orchestration/benchmarks/': typeof AgentsOrchestrationBenchmarksIndexRoute
  '/agents/orchestration/filesystems/': typeof AgentsOrchestrationFilesystemsIndexRoute
  '/agents/orchestration/specs/': typeof AgentsOrchestrationSpecsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/api-keys'
    | '/app-connections'
    | '/chat'
    | '/knowledge-graphs'
    | '/mcp-connections'
    | '/settings'
    | '/skills'
    | '/users'
    | '/agents/$agentId'
    | '/agents/assistant'
    | '/agents/auto-approve'
    | '/agents/collections'
    | '/agents/new'
    | '/agents/sessions'
    | '/agents/skills'
    | '/board-columns/$columnId'
    | '/board-columns/new'
    | '/bot/$threadId'
    | '/chat/$threadId'
    | '/dashboards/$dashboardId'
    | '/document-sets/$setId'
    | '/evals/new'
    | '/ground-truth/bulk'
    | '/ground-truth/new'
    | '/inbox/board'
    | '/inbox/closed-signals'
    | '/inbox/coordinator'
    | '/internal/knowledge-graphs'
    | '/internal/remote-realtime-tools'
    | '/judges/$judgeId'
    | '/judges/new'
    | '/models/$modelId'
    | '/models/new'
    | '/orchestrator/analytics'
    | '/orchestrator/live'
    | '/signals/$id'
    | '/suites/$suiteId'
    | '/suites/new'
    | '/tasks/$taskId'
    | '/tasks/new'
    | '/traces/$traceId'
    | '/workspaces/$id'
    | '/agents/'
    | '/board-columns/'
    | '/chat/'
    | '/dashboards/'
    | '/document-sets/'
    | '/evals/'
    | '/feedback/'
    | '/ground-truth/'
    | '/inbox/'
    | '/internal/'
    | '/judges/'
    | '/memory/'
    | '/models/'
    | '/orchestrator/'
    | '/schedules/'
    | '/suites/'
    | '/tasks/'
    | '/traces/'
    | '/workflows/'
    | '/workspaces/'
    | '/agents/memories/digest'
    | '/agents/memories/metrics'
    | '/agents/orchestration/signals'
    | '/evals/$evalId/nodes'
    | '/inbox/elicitation/$elicitationId'
    | '/inbox/hitl/$runId'
    | '/internal/blueprints/$blueprintId'
    | '/internal/blueprints/new'
    | '/internal/organizations/$orgId'
    | '/internal/organizations/new'
    | '/internal/pipelines/$pipelineId'
    | '/internal/pipelines/new'
    | '/triage/hitl/$runId'
    | '/triage/runs/$runId'
    | '/workflows/agents/$agentId'
    | '/workflows/agents/new'
    | '/agents/memories/'
    | '/agents/orchestration/'
    | '/evals/$evalId/'
    | '/internal/blueprints/'
    | '/internal/organizations/'
    | '/internal/pipelines/'
    | '/memory/metrics/'
    | '/refinement/history/'
    | '/refinement/overview/'
    | '/refinement/schedules/'
    | '/triage/hitl/'
    | '/triage/runs/'
    | '/workflows/$workflowId/'
    | '/workflows/agents/'
    | '/agents/$agentId/threads/$threadId'
    | '/agents/orchestration/benchmarks/$benchmarkId'
    | '/agents/orchestration/filesystems/$filesystemId'
    | '/agents/orchestration/specs/$specId'
    | '/agents/orchestration/benchmarks/'
    | '/agents/orchestration/filesystems/'
    | '/agents/orchestration/specs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/api-keys'
    | '/app-connections'
    | '/knowledge-graphs'
    | '/mcp-connections'
    | '/settings'
    | '/skills'
    | '/users'
    | '/agents/$agentId'
    | '/agents/assistant'
    | '/agents/auto-approve'
    | '/agents/collections'
    | '/agents/new'
    | '/agents/sessions'
    | '/agents/skills'
    | '/board-columns/$columnId'
    | '/board-columns/new'
    | '/bot/$threadId'
    | '/chat/$threadId'
    | '/dashboards/$dashboardId'
    | '/document-sets/$setId'
    | '/evals/new'
    | '/ground-truth/bulk'
    | '/ground-truth/new'
    | '/inbox/board'
    | '/inbox/closed-signals'
    | '/inbox/coordinator'
    | '/internal/knowledge-graphs'
    | '/internal/remote-realtime-tools'
    | '/judges/$judgeId'
    | '/judges/new'
    | '/models/$modelId'
    | '/models/new'
    | '/orchestrator/analytics'
    | '/orchestrator/live'
    | '/signals/$id'
    | '/suites/$suiteId'
    | '/suites/new'
    | '/tasks/$taskId'
    | '/tasks/new'
    | '/traces/$traceId'
    | '/workspaces/$id'
    | '/agents'
    | '/board-columns'
    | '/chat'
    | '/dashboards'
    | '/document-sets'
    | '/evals'
    | '/feedback'
    | '/ground-truth'
    | '/inbox'
    | '/internal'
    | '/judges'
    | '/memory'
    | '/models'
    | '/orchestrator'
    | '/schedules'
    | '/suites'
    | '/tasks'
    | '/traces'
    | '/workflows'
    | '/workspaces'
    | '/agents/memories/digest'
    | '/agents/memories/metrics'
    | '/agents/orchestration/signals'
    | '/evals/$evalId/nodes'
    | '/inbox/elicitation/$elicitationId'
    | '/inbox/hitl/$runId'
    | '/internal/blueprints/$blueprintId'
    | '/internal/blueprints/new'
    | '/internal/organizations/$orgId'
    | '/internal/organizations/new'
    | '/internal/pipelines/$pipelineId'
    | '/internal/pipelines/new'
    | '/triage/hitl/$runId'
    | '/triage/runs/$runId'
    | '/workflows/agents/$agentId'
    | '/workflows/agents/new'
    | '/agents/memories'
    | '/agents/orchestration'
    | '/evals/$evalId'
    | '/internal/blueprints'
    | '/internal/organizations'
    | '/internal/pipelines'
    | '/memory/metrics'
    | '/refinement/history'
    | '/refinement/overview'
    | '/refinement/schedules'
    | '/triage/hitl'
    | '/triage/runs'
    | '/workflows/$workflowId'
    | '/workflows/agents'
    | '/agents/$agentId/threads/$threadId'
    | '/agents/orchestration/benchmarks/$benchmarkId'
    | '/agents/orchestration/filesystems/$filesystemId'
    | '/agents/orchestration/specs/$specId'
    | '/agents/orchestration/benchmarks'
    | '/agents/orchestration/filesystems'
    | '/agents/orchestration/specs'
  id:
    | '__root__'
    | '/'
    | '/api-keys'
    | '/app-connections'
    | '/chat'
    | '/knowledge-graphs'
    | '/mcp-connections'
    | '/settings'
    | '/skills'
    | '/users'
    | '/agents/$agentId'
    | '/agents/assistant'
    | '/agents/auto-approve'
    | '/agents/collections'
    | '/agents/new'
    | '/agents/sessions'
    | '/agents/skills'
    | '/board-columns/$columnId'
    | '/board-columns/new'
    | '/bot/$threadId'
    | '/chat/$threadId'
    | '/dashboards/$dashboardId'
    | '/document-sets/$setId'
    | '/evals/new'
    | '/ground-truth/bulk'
    | '/ground-truth/new'
    | '/inbox/board'
    | '/inbox/closed-signals'
    | '/inbox/coordinator'
    | '/internal/knowledge-graphs'
    | '/internal/remote-realtime-tools'
    | '/judges/$judgeId'
    | '/judges/new'
    | '/models/$modelId'
    | '/models/new'
    | '/orchestrator/analytics'
    | '/orchestrator/live'
    | '/signals/$id'
    | '/suites/$suiteId'
    | '/suites/new'
    | '/tasks/$taskId'
    | '/tasks/new'
    | '/traces/$traceId'
    | '/workspaces/$id'
    | '/agents/'
    | '/board-columns/'
    | '/chat/'
    | '/dashboards/'
    | '/document-sets/'
    | '/evals/'
    | '/feedback/'
    | '/ground-truth/'
    | '/inbox/'
    | '/internal/'
    | '/judges/'
    | '/memory/'
    | '/models/'
    | '/orchestrator/'
    | '/schedules/'
    | '/suites/'
    | '/tasks/'
    | '/traces/'
    | '/workflows/'
    | '/workspaces/'
    | '/agents/memories/digest'
    | '/agents/memories/metrics'
    | '/agents/orchestration/signals'
    | '/evals/$evalId/nodes'
    | '/inbox/elicitation/$elicitationId'
    | '/inbox/hitl/$runId'
    | '/internal/blueprints/$blueprintId'
    | '/internal/blueprints/new'
    | '/internal/organizations/$orgId'
    | '/internal/organizations/new'
    | '/internal/pipelines/$pipelineId'
    | '/internal/pipelines/new'
    | '/triage/hitl/$runId'
    | '/triage/runs/$runId'
    | '/workflows/agents/$agentId'
    | '/workflows/agents/new'
    | '/agents/memories/'
    | '/agents/orchestration/'
    | '/evals/$evalId/'
    | '/internal/blueprints/'
    | '/internal/organizations/'
    | '/internal/pipelines/'
    | '/memory/metrics/'
    | '/refinement/history/'
    | '/refinement/overview/'
    | '/refinement/schedules/'
    | '/triage/hitl/'
    | '/triage/runs/'
    | '/workflows/$workflowId/'
    | '/workflows/agents/'
    | '/agents/$agentId_/threads/$threadId'
    | '/agents/orchestration/benchmarks/$benchmarkId'
    | '/agents/orchestration/filesystems/$filesystemId'
    | '/agents/orchestration/specs/$specId'
    | '/agents/orchestration/benchmarks/'
    | '/agents/orchestration/filesystems/'
    | '/agents/orchestration/specs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ApiKeysRoute: typeof ApiKeysRoute
  AppConnectionsRoute: typeof AppConnectionsRoute
  ChatRoute: typeof ChatRouteWithChildren
  KnowledgeGraphsRoute: typeof KnowledgeGraphsRoute
  McpConnectionsRoute: typeof McpConnectionsRoute
  SettingsRoute: typeof SettingsRoute
  SkillsRoute: typeof SkillsRoute
  UsersRoute: typeof UsersRoute
  AgentsAgentIdRoute: typeof AgentsAgentIdRoute
  AgentsAssistantRoute: typeof AgentsAssistantRoute
  AgentsAutoApproveRoute: typeof AgentsAutoApproveRoute
  AgentsCollectionsRoute: typeof AgentsCollectionsRoute
  AgentsNewRoute: typeof AgentsNewRoute
  AgentsSessionsRoute: typeof AgentsSessionsRoute
  AgentsSkillsRoute: typeof AgentsSkillsRoute
  BoardColumnsColumnIdRoute: typeof BoardColumnsColumnIdRoute
  BoardColumnsNewRoute: typeof BoardColumnsNewRoute
  BotThreadIdRoute: typeof BotThreadIdRoute
  DashboardsDashboardIdRoute: typeof DashboardsDashboardIdRoute
  DocumentSetsSetIdRoute: typeof DocumentSetsSetIdRoute
  EvalsNewRoute: typeof EvalsNewRoute
  GroundTruthBulkRoute: typeof GroundTruthBulkRoute
  GroundTruthNewRoute: typeof GroundTruthNewRoute
  InboxBoardRoute: typeof InboxBoardRoute
  InboxClosedSignalsRoute: typeof InboxClosedSignalsRoute
  InboxCoordinatorRoute: typeof InboxCoordinatorRoute
  InternalKnowledgeGraphsRoute: typeof InternalKnowledgeGraphsRoute
  InternalRemoteRealtimeToolsRoute: typeof InternalRemoteRealtimeToolsRoute
  JudgesJudgeIdRoute: typeof JudgesJudgeIdRoute
  JudgesNewRoute: typeof JudgesNewRoute
  ModelsModelIdRoute: typeof ModelsModelIdRoute
  ModelsNewRoute: typeof ModelsNewRoute
  OrchestratorAnalyticsRoute: typeof OrchestratorAnalyticsRoute
  OrchestratorLiveRoute: typeof OrchestratorLiveRoute
  SignalsIdRoute: typeof SignalsIdRoute
  SuitesSuiteIdRoute: typeof SuitesSuiteIdRoute
  SuitesNewRoute: typeof SuitesNewRoute
  TasksTaskIdRoute: typeof TasksTaskIdRoute
  TasksNewRoute: typeof TasksNewRoute
  TracesTraceIdRoute: typeof TracesTraceIdRoute
  WorkspacesIdRoute: typeof WorkspacesIdRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
  BoardColumnsIndexRoute: typeof BoardColumnsIndexRoute
  DashboardsIndexRoute: typeof DashboardsIndexRoute
  DocumentSetsIndexRoute: typeof DocumentSetsIndexRoute
  EvalsIndexRoute: typeof EvalsIndexRoute
  FeedbackIndexRoute: typeof FeedbackIndexRoute
  GroundTruthIndexRoute: typeof GroundTruthIndexRoute
  InboxIndexRoute: typeof InboxIndexRoute
  InternalIndexRoute: typeof InternalIndexRoute
  JudgesIndexRoute: typeof JudgesIndexRoute
  MemoryIndexRoute: typeof MemoryIndexRoute
  ModelsIndexRoute: typeof ModelsIndexRoute
  OrchestratorIndexRoute: typeof OrchestratorIndexRoute
  SchedulesIndexRoute: typeof SchedulesIndexRoute
  SuitesIndexRoute: typeof SuitesIndexRoute
  TasksIndexRoute: typeof TasksIndexRoute
  TracesIndexRoute: typeof TracesIndexRoute
  WorkflowsIndexRoute: typeof WorkflowsIndexRoute
  WorkspacesIndexRoute: typeof WorkspacesIndexRoute
  AgentsMemoriesDigestRoute: typeof AgentsMemoriesDigestRoute
  AgentsMemoriesMetricsRoute: typeof AgentsMemoriesMetricsRoute
  AgentsOrchestrationSignalsRoute: typeof AgentsOrchestrationSignalsRoute
  EvalsEvalIdNodesRoute: typeof EvalsEvalIdNodesRoute
  InboxElicitationElicitationIdRoute: typeof InboxElicitationElicitationIdRoute
  InboxHitlRunIdRoute: typeof InboxHitlRunIdRoute
  InternalBlueprintsBlueprintIdRoute: typeof InternalBlueprintsBlueprintIdRoute
  InternalBlueprintsNewRoute: typeof InternalBlueprintsNewRoute
  InternalOrganizationsOrgIdRoute: typeof InternalOrganizationsOrgIdRoute
  InternalOrganizationsNewRoute: typeof InternalOrganizationsNewRoute
  InternalPipelinesPipelineIdRoute: typeof InternalPipelinesPipelineIdRoute
  InternalPipelinesNewRoute: typeof InternalPipelinesNewRoute
  TriageHitlRunIdRoute: typeof TriageHitlRunIdRoute
  TriageRunsRunIdRoute: typeof TriageRunsRunIdRoute
  WorkflowsAgentsAgentIdRoute: typeof WorkflowsAgentsAgentIdRoute
  WorkflowsAgentsNewRoute: typeof WorkflowsAgentsNewRoute
  AgentsMemoriesIndexRoute: typeof AgentsMemoriesIndexRoute
  AgentsOrchestrationIndexRoute: typeof AgentsOrchestrationIndexRoute
  EvalsEvalIdIndexRoute: typeof EvalsEvalIdIndexRoute
  InternalBlueprintsIndexRoute: typeof InternalBlueprintsIndexRoute
  InternalOrganizationsIndexRoute: typeof InternalOrganizationsIndexRoute
  InternalPipelinesIndexRoute: typeof InternalPipelinesIndexRoute
  MemoryMetricsIndexRoute: typeof MemoryMetricsIndexRoute
  RefinementHistoryIndexRoute: typeof RefinementHistoryIndexRoute
  RefinementOverviewIndexRoute: typeof RefinementOverviewIndexRoute
  RefinementSchedulesIndexRoute: typeof RefinementSchedulesIndexRoute
  TriageHitlIndexRoute: typeof TriageHitlIndexRoute
  TriageRunsIndexRoute: typeof TriageRunsIndexRoute
  WorkflowsWorkflowIdIndexRoute: typeof WorkflowsWorkflowIdIndexRoute
  WorkflowsAgentsIndexRoute: typeof WorkflowsAgentsIndexRoute
  AgentsAgentIdThreadsThreadIdRoute: typeof AgentsAgentIdThreadsThreadIdRoute
  AgentsOrchestrationBenchmarksBenchmarkIdRoute: typeof AgentsOrchestrationBenchmarksBenchmarkIdRoute
  AgentsOrchestrationFilesystemsFilesystemIdRoute: typeof AgentsOrchestrationFilesystemsFilesystemIdRoute
  AgentsOrchestrationSpecsSpecIdRoute: typeof AgentsOrchestrationSpecsSpecIdRoute
  AgentsOrchestrationBenchmarksIndexRoute: typeof AgentsOrchestrationBenchmarksIndexRoute
  AgentsOrchestrationFilesystemsIndexRoute: typeof AgentsOrchestrationFilesystemsIndexRoute
  AgentsOrchestrationSpecsIndexRoute: typeof AgentsOrchestrationSpecsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skills': {
      id: '/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof SkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp-connections': {
      id: '/mcp-connections'
      path: '/mcp-connections'
      fullPath: '/mcp-connections'
      preLoaderRoute: typeof McpConnectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge-graphs': {
      id: '/knowledge-graphs'
      path: '/knowledge-graphs'
      fullPath: '/knowledge-graphs'
      preLoaderRoute: typeof KnowledgeGraphsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app-connections': {
      id: '/app-connections'
      path: '/app-connections'
      fullPath: '/app-connections'
      preLoaderRoute: typeof AppConnectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-keys': {
      id: '/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof ApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/': {
      id: '/workspaces/'
      path: '/workspaces'
      fullPath: '/workspaces/'
      preLoaderRoute: typeof WorkspacesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflows/': {
      id: '/workflows/'
      path: '/workflows'
      fullPath: '/workflows/'
      preLoaderRoute: typeof WorkflowsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/traces/': {
      id: '/traces/'
      path: '/traces'
      fullPath: '/traces/'
      preLoaderRoute: typeof TracesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suites/': {
      id: '/suites/'
      path: '/suites'
      fullPath: '/suites/'
      preLoaderRoute: typeof SuitesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedules/': {
      id: '/schedules/'
      path: '/schedules'
      fullPath: '/schedules/'
      preLoaderRoute: typeof SchedulesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orchestrator/': {
      id: '/orchestrator/'
      path: '/orchestrator'
      fullPath: '/orchestrator/'
      preLoaderRoute: typeof OrchestratorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/models/': {
      id: '/models/'
      path: '/models'
      fullPath: '/models/'
      preLoaderRoute: typeof ModelsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memory/': {
      id: '/memory/'
      path: '/memory'
      fullPath: '/memory/'
      preLoaderRoute: typeof MemoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/judges/': {
      id: '/judges/'
      path: '/judges'
      fullPath: '/judges/'
      preLoaderRoute: typeof JudgesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/': {
      id: '/internal/'
      path: '/internal'
      fullPath: '/internal/'
      preLoaderRoute: typeof InternalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/': {
      id: '/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof InboxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ground-truth/': {
      id: '/ground-truth/'
      path: '/ground-truth'
      fullPath: '/ground-truth/'
      preLoaderRoute: typeof GroundTruthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback/': {
      id: '/feedback/'
      path: '/feedback'
      fullPath: '/feedback/'
      preLoaderRoute: typeof FeedbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evals/': {
      id: '/evals/'
      path: '/evals'
      fullPath: '/evals/'
      preLoaderRoute: typeof EvalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document-sets/': {
      id: '/document-sets/'
      path: '/document-sets'
      fullPath: '/document-sets/'
      preLoaderRoute: typeof DocumentSetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboards/': {
      id: '/dashboards/'
      path: '/dashboards'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof DashboardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/': {
      id: '/chat/'
      path: '/'
      fullPath: '/chat/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/board-columns/': {
      id: '/board-columns/'
      path: '/board-columns'
      fullPath: '/board-columns/'
      preLoaderRoute: typeof BoardColumnsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/': {
      id: '/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/$id': {
      id: '/workspaces/$id'
      path: '/workspaces/$id'
      fullPath: '/workspaces/$id'
      preLoaderRoute: typeof WorkspacesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/traces/$traceId': {
      id: '/traces/$traceId'
      path: '/traces/$traceId'
      fullPath: '/traces/$traceId'
      preLoaderRoute: typeof TracesTraceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/new': {
      id: '/tasks/new'
      path: '/tasks/new'
      fullPath: '/tasks/new'
      preLoaderRoute: typeof TasksNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suites/new': {
      id: '/suites/new'
      path: '/suites/new'
      fullPath: '/suites/new'
      preLoaderRoute: typeof SuitesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suites/$suiteId': {
      id: '/suites/$suiteId'
      path: '/suites/$suiteId'
      fullPath: '/suites/$suiteId'
      preLoaderRoute: typeof SuitesSuiteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signals/$id': {
      id: '/signals/$id'
      path: '/signals/$id'
      fullPath: '/signals/$id'
      preLoaderRoute: typeof SignalsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orchestrator/live': {
      id: '/orchestrator/live'
      path: '/orchestrator/live'
      fullPath: '/orchestrator/live'
      preLoaderRoute: typeof OrchestratorLiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orchestrator/analytics': {
      id: '/orchestrator/analytics'
      path: '/orchestrator/analytics'
      fullPath: '/orchestrator/analytics'
      preLoaderRoute: typeof OrchestratorAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/models/new': {
      id: '/models/new'
      path: '/models/new'
      fullPath: '/models/new'
      preLoaderRoute: typeof ModelsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/models/$modelId': {
      id: '/models/$modelId'
      path: '/models/$modelId'
      fullPath: '/models/$modelId'
      preLoaderRoute: typeof ModelsModelIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/judges/new': {
      id: '/judges/new'
      path: '/judges/new'
      fullPath: '/judges/new'
      preLoaderRoute: typeof JudgesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/judges/$judgeId': {
      id: '/judges/$judgeId'
      path: '/judges/$judgeId'
      fullPath: '/judges/$judgeId'
      preLoaderRoute: typeof JudgesJudgeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/remote-realtime-tools': {
      id: '/internal/remote-realtime-tools'
      path: '/internal/remote-realtime-tools'
      fullPath: '/internal/remote-realtime-tools'
      preLoaderRoute: typeof InternalRemoteRealtimeToolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/knowledge-graphs': {
      id: '/internal/knowledge-graphs'
      path: '/internal/knowledge-graphs'
      fullPath: '/internal/knowledge-graphs'
      preLoaderRoute: typeof InternalKnowledgeGraphsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/coordinator': {
      id: '/inbox/coordinator'
      path: '/inbox/coordinator'
      fullPath: '/inbox/coordinator'
      preLoaderRoute: typeof InboxCoordinatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/closed-signals': {
      id: '/inbox/closed-signals'
      path: '/inbox/closed-signals'
      fullPath: '/inbox/closed-signals'
      preLoaderRoute: typeof InboxClosedSignalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/board': {
      id: '/inbox/board'
      path: '/inbox/board'
      fullPath: '/inbox/board'
      preLoaderRoute: typeof InboxBoardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ground-truth/new': {
      id: '/ground-truth/new'
      path: '/ground-truth/new'
      fullPath: '/ground-truth/new'
      preLoaderRoute: typeof GroundTruthNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ground-truth/bulk': {
      id: '/ground-truth/bulk'
      path: '/ground-truth/bulk'
      fullPath: '/ground-truth/bulk'
      preLoaderRoute: typeof GroundTruthBulkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evals/new': {
      id: '/evals/new'
      path: '/evals/new'
      fullPath: '/evals/new'
      preLoaderRoute: typeof EvalsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document-sets/$setId': {
      id: '/document-sets/$setId'
      path: '/document-sets/$setId'
      fullPath: '/document-sets/$setId'
      preLoaderRoute: typeof DocumentSetsSetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboards/$dashboardId': {
      id: '/dashboards/$dashboardId'
      path: '/dashboards/$dashboardId'
      fullPath: '/dashboards/$dashboardId'
      preLoaderRoute: typeof DashboardsDashboardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$threadId': {
      id: '/chat/$threadId'
      path: '/$threadId'
      fullPath: '/chat/$threadId'
      preLoaderRoute: typeof ChatThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/bot/$threadId': {
      id: '/bot/$threadId'
      path: '/bot/$threadId'
      fullPath: '/bot/$threadId'
      preLoaderRoute: typeof BotThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/board-columns/new': {
      id: '/board-columns/new'
      path: '/board-columns/new'
      fullPath: '/board-columns/new'
      preLoaderRoute: typeof BoardColumnsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/board-columns/$columnId': {
      id: '/board-columns/$columnId'
      path: '/board-columns/$columnId'
      fullPath: '/board-columns/$columnId'
      preLoaderRoute: typeof BoardColumnsColumnIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/skills': {
      id: '/agents/skills'
      path: '/agents/skills'
      fullPath: '/agents/skills'
      preLoaderRoute: typeof AgentsSkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/sessions': {
      id: '/agents/sessions'
      path: '/agents/sessions'
      fullPath: '/agents/sessions'
      preLoaderRoute: typeof AgentsSessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/new': {
      id: '/agents/new'
      path: '/agents/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof AgentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/collections': {
      id: '/agents/collections'
      path: '/agents/collections'
      fullPath: '/agents/collections'
      preLoaderRoute: typeof AgentsCollectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/auto-approve': {
      id: '/agents/auto-approve'
      path: '/agents/auto-approve'
      fullPath: '/agents/auto-approve'
      preLoaderRoute: typeof AgentsAutoApproveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/assistant': {
      id: '/agents/assistant'
      path: '/agents/assistant'
      fullPath: '/agents/assistant'
      preLoaderRoute: typeof AgentsAssistantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agentId': {
      id: '/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AgentsAgentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflows/agents/': {
      id: '/workflows/agents/'
      path: '/workflows/agents'
      fullPath: '/workflows/agents/'
      preLoaderRoute: typeof WorkflowsAgentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflows/$workflowId/': {
      id: '/workflows/$workflowId/'
      path: '/workflows/$workflowId'
      fullPath: '/workflows/$workflowId/'
      preLoaderRoute: typeof WorkflowsWorkflowIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/triage/runs/': {
      id: '/triage/runs/'
      path: '/triage/runs'
      fullPath: '/triage/runs/'
      preLoaderRoute: typeof TriageRunsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/triage/hitl/': {
      id: '/triage/hitl/'
      path: '/triage/hitl'
      fullPath: '/triage/hitl/'
      preLoaderRoute: typeof TriageHitlIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refinement/schedules/': {
      id: '/refinement/schedules/'
      path: '/refinement/schedules'
      fullPath: '/refinement/schedules/'
      preLoaderRoute: typeof RefinementSchedulesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refinement/overview/': {
      id: '/refinement/overview/'
      path: '/refinement/overview'
      fullPath: '/refinement/overview/'
      preLoaderRoute: typeof RefinementOverviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refinement/history/': {
      id: '/refinement/history/'
      path: '/refinement/history'
      fullPath: '/refinement/history/'
      preLoaderRoute: typeof RefinementHistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memory/metrics/': {
      id: '/memory/metrics/'
      path: '/memory/metrics'
      fullPath: '/memory/metrics/'
      preLoaderRoute: typeof MemoryMetricsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/pipelines/': {
      id: '/internal/pipelines/'
      path: '/internal/pipelines'
      fullPath: '/internal/pipelines/'
      preLoaderRoute: typeof InternalPipelinesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/organizations/': {
      id: '/internal/organizations/'
      path: '/internal/organizations'
      fullPath: '/internal/organizations/'
      preLoaderRoute: typeof InternalOrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/blueprints/': {
      id: '/internal/blueprints/'
      path: '/internal/blueprints'
      fullPath: '/internal/blueprints/'
      preLoaderRoute: typeof InternalBlueprintsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evals/$evalId/': {
      id: '/evals/$evalId/'
      path: '/evals/$evalId'
      fullPath: '/evals/$evalId/'
      preLoaderRoute: typeof EvalsEvalIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/orchestration/': {
      id: '/agents/orchestration/'
      path: '/agents/orchestration'
      fullPath: '/agents/orchestration/'
      preLoaderRoute: typeof AgentsOrchestrationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/memories/': {
      id: '/agents/memories/'
      path: '/agents/memories'
      fullPath: '/agents/memories/'
      preLoaderRoute: typeof AgentsMemoriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflows/agents/new': {
      id: '/workflows/agents/new'
      path: '/workflows/agents/new'
      fullPath: '/workflows/agents/new'
      preLoaderRoute: typeof WorkflowsAgentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflows/agents/$agentId': {
      id: '/workflows/agents/$agentId'
      path: '/workflows/agents/$agentId'
      fullPath: '/workflows/agents/$agentId'
      preLoaderRoute: typeof WorkflowsAgentsAgentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/triage/runs/$runId': {
      id: '/triage/runs/$runId'
      path: '/triage/runs/$runId'
      fullPath: '/triage/runs/$runId'
      preLoaderRoute: typeof TriageRunsRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/triage/hitl/$runId': {
      id: '/triage/hitl/$runId'
      path: '/triage/hitl/$runId'
      fullPath: '/triage/hitl/$runId'
      preLoaderRoute: typeof TriageHitlRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/pipelines/new': {
      id: '/internal/pipelines/new'
      path: '/internal/pipelines/new'
      fullPath: '/internal/pipelines/new'
      preLoaderRoute: typeof InternalPipelinesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/pipelines/$pipelineId': {
      id: '/internal/pipelines/$pipelineId'
      path: '/internal/pipelines/$pipelineId'
      fullPath: '/internal/pipelines/$pipelineId'
      preLoaderRoute: typeof InternalPipelinesPipelineIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/organizations/new': {
      id: '/internal/organizations/new'
      path: '/internal/organizations/new'
      fullPath: '/internal/organizations/new'
      preLoaderRoute: typeof InternalOrganizationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/organizations/$orgId': {
      id: '/internal/organizations/$orgId'
      path: '/internal/organizations/$orgId'
      fullPath: '/internal/organizations/$orgId'
      preLoaderRoute: typeof InternalOrganizationsOrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/blueprints/new': {
      id: '/internal/blueprints/new'
      path: '/internal/blueprints/new'
      fullPath: '/internal/blueprints/new'
      preLoaderRoute: typeof InternalBlueprintsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/blueprints/$blueprintId': {
      id: '/internal/blueprints/$blueprintId'
      path: '/internal/blueprints/$blueprintId'
      fullPath: '/internal/blueprints/$blueprintId'
      preLoaderRoute: typeof InternalBlueprintsBlueprintIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/hitl/$runId': {
      id: '/inbox/hitl/$runId'
      path: '/inbox/hitl/$runId'
      fullPath: '/inbox/hitl/$runId'
      preLoaderRoute: typeof InboxHitlRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/elicitation/$elicitationId': {
      id: '/inbox/elicitation/$elicitationId'
      path: '/inbox/elicitation/$elicitationId'
      fullPath: '/inbox/elicitation/$elicitationId'
      preLoaderRoute: typeof InboxElicitationElicitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evals/$evalId/nodes': {
      id: '/evals/$evalId/nodes'
      path: '/evals/$evalId/nodes'
      fullPath: '/evals/$evalId/nodes'
      preLoaderRoute: typeof EvalsEvalIdNodesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/orchestration/signals': {
      id: '/agents/orchestration/signals'
      path: '/agents/orchestration/signals'
      fullPath: '/agents/orchestration/signals'
      preLoaderRoute: typeof AgentsOrchestrationSignalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/memories/metrics': {
      id: '/agents/memories/metrics'
      path: '/agents/memories/metrics'
      fullPath: '/agents/memories/metrics'
      preLoaderRoute: typeof AgentsMemoriesMetricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/memories/digest': {
      id: '/agents/memories/digest'
      path: '/agents/memories/digest'
      fullPath: '/agents/memories/digest'
      preLoaderRoute: typeof AgentsMemoriesDigestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/orchestration/specs/': {
      id: '/agents/orchestration/specs/'
      path: '/agents/orchestration/specs'
      fullPath: '/agents/orchestration/specs/'
      preLoaderRoute: typeof AgentsOrchestrationSpecsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/orchestration/filesystems/': {
      id: '/agents/orchestration/filesystems/'
      path: '/agents/orchestration/filesystems'
      fullPath: '/agents/orchestration/filesystems/'
      preLoaderRoute: typeof AgentsOrchestrationFilesystemsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/orchestration/benchmarks/': {
      id: '/agents/orchestration/benchmarks/'
      path: '/agents/orchestration/benchmarks'
      fullPath: '/agents/orchestration/benchmarks/'
      preLoaderRoute: typeof AgentsOrchestrationBenchmarksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/orchestration/specs/$specId': {
      id: '/agents/orchestration/specs/$specId'
      path: '/agents/orchestration/specs/$specId'
      fullPath: '/agents/orchestration/specs/$specId'
      preLoaderRoute: typeof AgentsOrchestrationSpecsSpecIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/orchestration/filesystems/$filesystemId': {
      id: '/agents/orchestration/filesystems/$filesystemId'
      path: '/agents/orchestration/filesystems/$filesystemId'
      fullPath: '/agents/orchestration/filesystems/$filesystemId'
      preLoaderRoute: typeof AgentsOrchestrationFilesystemsFilesystemIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/orchestration/benchmarks/$benchmarkId': {
      id: '/agents/orchestration/benchmarks/$benchmarkId'
      path: '/agents/orchestration/benchmarks/$benchmarkId'
      fullPath: '/agents/orchestration/benchmarks/$benchmarkId'
      preLoaderRoute: typeof AgentsOrchestrationBenchmarksBenchmarkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agentId_/threads/$threadId': {
      id: '/agents/$agentId_/threads/$threadId'
      path: '/agents/$agentId/threads/$threadId'
      fullPath: '/agents/$agentId/threads/$threadId'
      preLoaderRoute: typeof AgentsAgentIdThreadsThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ChatRouteChildren {
  ChatThreadIdRoute: typeof ChatThreadIdRoute
  ChatIndexRoute: typeof ChatIndexRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatThreadIdRoute: ChatThreadIdRoute,
  ChatIndexRoute: ChatIndexRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApiKeysRoute: ApiKeysRoute,
  AppConnectionsRoute: AppConnectionsRoute,
  ChatRoute: ChatRouteWithChildren,
  KnowledgeGraphsRoute: KnowledgeGraphsRoute,
  McpConnectionsRoute: McpConnectionsRoute,
  SettingsRoute: SettingsRoute,
  SkillsRoute: SkillsRoute,
  UsersRoute: UsersRoute,
  AgentsAgentIdRoute: AgentsAgentIdRoute,
  AgentsAssistantRoute: AgentsAssistantRoute,
  AgentsAutoApproveRoute: AgentsAutoApproveRoute,
  AgentsCollectionsRoute: AgentsCollectionsRoute,
  AgentsNewRoute: AgentsNewRoute,
  AgentsSessionsRoute: AgentsSessionsRoute,
  AgentsSkillsRoute: AgentsSkillsRoute,
  BoardColumnsColumnIdRoute: BoardColumnsColumnIdRoute,
  BoardColumnsNewRoute: BoardColumnsNewRoute,
  BotThreadIdRoute: BotThreadIdRoute,
  DashboardsDashboardIdRoute: DashboardsDashboardIdRoute,
  DocumentSetsSetIdRoute: DocumentSetsSetIdRoute,
  EvalsNewRoute: EvalsNewRoute,
  GroundTruthBulkRoute: GroundTruthBulkRoute,
  GroundTruthNewRoute: GroundTruthNewRoute,
  InboxBoardRoute: InboxBoardRoute,
  InboxClosedSignalsRoute: InboxClosedSignalsRoute,
  InboxCoordinatorRoute: InboxCoordinatorRoute,
  InternalKnowledgeGraphsRoute: InternalKnowledgeGraphsRoute,
  InternalRemoteRealtimeToolsRoute: InternalRemoteRealtimeToolsRoute,
  JudgesJudgeIdRoute: JudgesJudgeIdRoute,
  JudgesNewRoute: JudgesNewRoute,
  ModelsModelIdRoute: ModelsModelIdRoute,
  ModelsNewRoute: ModelsNewRoute,
  OrchestratorAnalyticsRoute: OrchestratorAnalyticsRoute,
  OrchestratorLiveRoute: OrchestratorLiveRoute,
  SignalsIdRoute: SignalsIdRoute,
  SuitesSuiteIdRoute: SuitesSuiteIdRoute,
  SuitesNewRoute: SuitesNewRoute,
  TasksTaskIdRoute: TasksTaskIdRoute,
  TasksNewRoute: TasksNewRoute,
  TracesTraceIdRoute: TracesTraceIdRoute,
  WorkspacesIdRoute: WorkspacesIdRoute,
  AgentsIndexRoute: AgentsIndexRoute,
  BoardColumnsIndexRoute: BoardColumnsIndexRoute,
  DashboardsIndexRoute: DashboardsIndexRoute,
  DocumentSetsIndexRoute: DocumentSetsIndexRoute,
  EvalsIndexRoute: EvalsIndexRoute,
  FeedbackIndexRoute: FeedbackIndexRoute,
  GroundTruthIndexRoute: GroundTruthIndexRoute,
  InboxIndexRoute: InboxIndexRoute,
  InternalIndexRoute: InternalIndexRoute,
  JudgesIndexRoute: JudgesIndexRoute,
  MemoryIndexRoute: MemoryIndexRoute,
  ModelsIndexRoute: ModelsIndexRoute,
  OrchestratorIndexRoute: OrchestratorIndexRoute,
  SchedulesIndexRoute: SchedulesIndexRoute,
  SuitesIndexRoute: SuitesIndexRoute,
  TasksIndexRoute: TasksIndexRoute,
  TracesIndexRoute: TracesIndexRoute,
  WorkflowsIndexRoute: WorkflowsIndexRoute,
  WorkspacesIndexRoute: WorkspacesIndexRoute,
  AgentsMemoriesDigestRoute: AgentsMemoriesDigestRoute,
  AgentsMemoriesMetricsRoute: AgentsMemoriesMetricsRoute,
  AgentsOrchestrationSignalsRoute: AgentsOrchestrationSignalsRoute,
  EvalsEvalIdNodesRoute: EvalsEvalIdNodesRoute,
  InboxElicitationElicitationIdRoute: InboxElicitationElicitationIdRoute,
  InboxHitlRunIdRoute: InboxHitlRunIdRoute,
  InternalBlueprintsBlueprintIdRoute: InternalBlueprintsBlueprintIdRoute,
  InternalBlueprintsNewRoute: InternalBlueprintsNewRoute,
  InternalOrganizationsOrgIdRoute: InternalOrganizationsOrgIdRoute,
  InternalOrganizationsNewRoute: InternalOrganizationsNewRoute,
  InternalPipelinesPipelineIdRoute: InternalPipelinesPipelineIdRoute,
  InternalPipelinesNewRoute: InternalPipelinesNewRoute,
  TriageHitlRunIdRoute: TriageHitlRunIdRoute,
  TriageRunsRunIdRoute: TriageRunsRunIdRoute,
  WorkflowsAgentsAgentIdRoute: WorkflowsAgentsAgentIdRoute,
  WorkflowsAgentsNewRoute: WorkflowsAgentsNewRoute,
  AgentsMemoriesIndexRoute: AgentsMemoriesIndexRoute,
  AgentsOrchestrationIndexRoute: AgentsOrchestrationIndexRoute,
  EvalsEvalIdIndexRoute: EvalsEvalIdIndexRoute,
  InternalBlueprintsIndexRoute: InternalBlueprintsIndexRoute,
  InternalOrganizationsIndexRoute: InternalOrganizationsIndexRoute,
  InternalPipelinesIndexRoute: InternalPipelinesIndexRoute,
  MemoryMetricsIndexRoute: MemoryMetricsIndexRoute,
  RefinementHistoryIndexRoute: RefinementHistoryIndexRoute,
  RefinementOverviewIndexRoute: RefinementOverviewIndexRoute,
  RefinementSchedulesIndexRoute: RefinementSchedulesIndexRoute,
  TriageHitlIndexRoute: TriageHitlIndexRoute,
  TriageRunsIndexRoute: TriageRunsIndexRoute,
  WorkflowsWorkflowIdIndexRoute: WorkflowsWorkflowIdIndexRoute,
  WorkflowsAgentsIndexRoute: WorkflowsAgentsIndexRoute,
  AgentsAgentIdThreadsThreadIdRoute: AgentsAgentIdThreadsThreadIdRoute,
  AgentsOrchestrationBenchmarksBenchmarkIdRoute:
    AgentsOrchestrationBenchmarksBenchmarkIdRoute,
  AgentsOrchestrationFilesystemsFilesystemIdRoute:
    AgentsOrchestrationFilesystemsFilesystemIdRoute,
  AgentsOrchestrationSpecsSpecIdRoute: AgentsOrchestrationSpecsSpecIdRoute,
  AgentsOrchestrationBenchmarksIndexRoute:
    AgentsOrchestrationBenchmarksIndexRoute,
  AgentsOrchestrationFilesystemsIndexRoute:
    AgentsOrchestrationFilesystemsIndexRoute,
  AgentsOrchestrationSpecsIndexRoute: AgentsOrchestrationSpecsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
